export const AUTH = {
    REGISTER_SUCCESS : "REGISTER_SUCCESS",
    REGISTER_FAIL : "REGISTER_FAIL",
    USER_INFORMATION : "USER_INFORMATION",
    REGISTER_USER_APPROVER_SUCCESS : "REGISTER_SUCCESS",
    REGISTER_USER_APPROVER_FAIL : "REGISTER_FAIL",
    LOGIN_SUCCESS : "LOGIN_SUCCESS",
    LOGIN_FAIL : "LOGIN_FAIL",
    LOGOUT : "LOGOUT",
    RECOVERY_SUCCESS: "RECOVERY_SUCCESS",
    RESETPASSWORD_SUCCESS:"RESETPASSWORD_SUCCESS"
}

export const MESSAGE = {
    SET_MESSAGE : "SET_MESSAGE",
    CLEAR_MESSAGE : "CLEAR_MESSAGE"
}

export const REQUEST = {
    CREATE_REQUEST_SUCCESS : "CREATE_REQUEST_SUCCESS",
    CREATE_REQUEST_FAIL : "CREATE_REQUEST_FAIL",
    GET_REQUEST :"GET_REQUEST",
    
}

export const PERSONAL = {
    GET_PERSONAL : "GET_PERSONAL",
    SET_EDIT_PERSONAL: "SET_EDIT_PERSONAL",
    DELETE_EDIT_PERSONAL: "DELETE_EDIT_PERSONAL",
}

export const VEHICLES = {
  GET_VEHICLES: "GET_VEHICLES",
  SET_EDIT_VEHICLE: "SET_EDIT_VEHICLE",
  DELETE_EDIT_VEHICLE: "DELETE_EDIT_VEHICLE",
};



